import { Beneficiario } from "../../../../../interfaces/entities/Beneficiario";
import { useAccessibility } from "../../../../../Store/contexts/AccessibilityContext";
import "./styles.css";

const BenefDataCard: React.FC<{ benef: string, cel: string, email: string }> = ({ benef, cel, email }) => {

  const { fontSizeStyleAccessibility } = useAccessibility();

  return (
    <div className="registration-data-card-holder">
      <div className="registration-data-card">
        <div className="registration-data-row">
          <span style={fontSizeStyleAccessibility} className="registration-data-title">Dados do beneficiário</span>
        </div>
        <div className="registration-data-row registration-data-row-secondary">
          <span style={fontSizeStyleAccessibility} className="registration-data-key">Nome</span>
          <span style={fontSizeStyleAccessibility} className="registration-data-value">{benef}</span>
        </div>
        <div className="registration-data-row">
          <span style={fontSizeStyleAccessibility} className="registration-data-key">Telefone</span>
          <span style={fontSizeStyleAccessibility} className="registration-data-value">{cel}</span>
        </div>
        <div className="registration-data-row registration-data-row-secondary radius-bottom">
          <span style={fontSizeStyleAccessibility} className="registration-data-key">E-mail</span>
          <span style={fontSizeStyleAccessibility} className="registration-data-value">{email}</span>
        </div>
      </div>
    </div>
  )
}

export default BenefDataCard;